import React, { useState } from 'react';
import { ShiftMatch } from 'models';
import { Colors } from 'library';
import { Chip, Link, Row, Stack, Text } from 'library/ui';
import moment from 'moment';

export function MatchStatusChips({ matches }: { matches: ShiftMatch[] }) {
    const numMatchesToShow = 3;
    const [showAllMatches, setShowAllMatches] = useState(false);

    const shownMatches = showAllMatches ? matches : matches.slice(0, numMatchesToShow);

    const getMatchChipStyle = (match: ShiftMatch) => {
        const now = moment();
        if (match.accepted_at && ['ON_STAFF', 'APPROVAL_NEEDED'].includes(match.pairing_status ?? '')) {
            return {
                label: 'Accepted',
                color: Colors.secondary,
            };
        }

        if (
            match.declined_at ||
            match.worker_booked ||
            ['SITTER_CANCELLED', 'APPLIED_CANCELLED'].includes(match.pairing_status ?? '')
        ) {
            return {
                label: 'Unavailable',
                color: Colors.error,
            };
        }

        if (moment(match.expires_at).isBefore(now)) {
            return {
                label: 'No response',
                color: Colors.error,
            };
        }
        return {
            label: 'Pending',
            color: Colors.accent,
        };
    };

    return matches && matches.length > 0 ? (
        <Stack gap="sm" align="start">
            <Text size="xs" weight="bold">
                Requested Worker(s)
            </Text>
            {shownMatches.map((match) => (
                <Row key={match.matched_worker.id} justify="between" align="center" fullWidth>
                    <Text>
                        {match.matched_worker.first_name} {match.matched_worker.last_name}
                    </Text>
                    <Chip
                        variant="filled"
                        bgColor={getMatchChipStyle(match).color}
                        textColor={Colors.white}
                        size="small"
                    >
                        {getMatchChipStyle(match).label}
                    </Chip>
                </Row>
            ))}
            {!showAllMatches && matches.length > numMatchesToShow && (
                <Link onClick={() => setShowAllMatches(true)}>view {matches.length - numMatchesToShow} more</Link>
            )}
            {showAllMatches && <Link onClick={() => setShowAllMatches(false)}>Hide</Link>}
        </Stack>
    ) : null;
}
